import { addMilliseconds } from "date-fns";
import { without } from "lodash";
import React, { useState } from "react";
import { TimesheetEntry } from "../../core/types";
import { formatDe } from "../../utils/date";
import styled from "./TimesheetEntryTable.styles";

interface TimesheetEntryTableProps {
  entries: TimesheetEntry[];
  editEvent: (entry: TimesheetEntry) => void;
}

const TimesheetEntryTable: React.FC<TimesheetEntryTableProps> = (props) => {
  const { editEvent, entries } = props;
  const [expanded, setExpanded] = useState<TimesheetEntry[]>([]);

  return (
    <styled.Container>
      <div>
        {entries.length === 0 && (
          <div className="text-center text-muted noEntries">
            Noch keine Einträge.
          </div>
        )}
        {entries.map((entry) => {
          return (
            <styled.Row key={`${entry.start}-${entry.duration}`}>
              <div
                className="timeSheetRow"
                style={{ display: "flex", overflow: "hidden" }}
              >
                <styled.TimeSpan>
                  <a
                    href=""
                    onClick={(ev) => {
                      ev.preventDefault();
                      editEvent(entry);
                    }}
                  >
                    {`${formatDe(entry.start, "HH:mm")} - ${formatDe(
                      addMilliseconds(entry.start, entry.duration),
                      "HH:mm"
                    )}`}
                  </a>
                </styled.TimeSpan>
                <styled.Duration>
                  {`${Math.round((entry.duration / 60000 / 60) * 100) / 100}h`}
                </styled.Duration>
                <styled.Description
                  title={entry.description}
                  onClick={(ev) => {
                    ev.preventDefault();
                    ev.stopPropagation();

                    setExpanded((expanded) =>
                      expanded.includes(entry)
                        ? without(expanded, entry)
                        : [...expanded, entry]
                    );
                  }}
                  expand={expanded.includes(entry)}
                  className="text-muted"
                >
                  {entry.description}
                </styled.Description>
              </div>
            </styled.Row>
          );
        })}
      </div>
    </styled.Container>
  );
};

export default TimesheetEntryTable;
